// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1zEq4","Success":"Button_Success__2gXrn","Danger":"Button_Danger__28K_M"};